<vdms-hq-selectors-field-values-table />
